import { _ } from '../../vendor'

import InboomaBaseFilterableCollection from './InboomaBaseFilterableCollection'

import Contingent from '../models/Contingent'
import Resources from '../collections/Resources'

export default InboomaBaseFilterableCollection.extend({
  
    collectionName : 'contingents',
    model : Contingent,
    url : '/contingents',

    initialize () {

        const that = this;

        this.bind("change", function() {
            // proof if element has resources models -> create models if not set
            _.each(that.models, (model) => {
                var res = model.get('resources');
                if (typeof res !== 'undefined' && typeof res.models === 'undefined' && res.length > 0) {
                    model.set('resources',new Resources(res));
                }
            });
        });
    },

    filterResourcetype (resourcetype_id) {

        if (resourcetype_id === null || resourcetype_id === '') {
            return this.removeFilter('resourcetype_id');
        }

        resourcetype_id = Number(resourcetype_id);

        return this.addFilter('resourcetype_id', resourcetype_id);
    },

    filterLocation (location_id) {

        if (location_id === null || location_id === '') {
            return this.removeFilter('location_id');
        }

        location_id = Number(location_id);

        return this.addFilter('location_id', location_id);
    },

    _pagination : {
      current_page : 0,
      sort : 'name',
      sortDirection : 'asc',
      has_next_page : false,
      has_prev_page : false,
      count : 0,
      limit : 50
    },

    _filterParams : {},

});